module.exports = __webpack_public_path__ + "media/images/application2/OrdersProcessing-f295c636ee2051b3b27c7989032bf305.png";